export default __webpack_public_path__ + "static/media/efecto-6.bb423887.webp";